module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_30.d5186a00.mp3";